var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.open)?_c('v-dialog',{attrs:{"persistent":_vm.modalIsPersistent,"max-width":_vm.modalMaxWidth,"fullscreen":_vm.fullscreen,"scrollable":_vm.scrollable},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c(_vm.open,_vm._b({tag:"component"},'component',_vm.modalProps,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }